import { StatsThemeMap } from '../types'
import { blue } from './blue'
import { darkGreen } from './darkGreen'
import { darkPink } from './darkPink'
import { green } from './green'
import { pink } from './pink'

export const statsThemes: StatsThemeMap = {
  pink,
  blue,
  green,
  dark_green: darkGreen,
  dark_pink: darkPink,
}
